export interface SalesDespatchCustomsSummaryReport {
  tariffCode: string;
  composition: string;
  nettQuantity: number;
  value: number;
}
